import type { ExpectedUserBenefitType } from '@openclassrooms/sdk-web';

import {
  useUserExpectedBenefits,
  useCurrentUserContext,
} from '@openclassrooms/data-connect-web/users';

import getMostRelevantBenefit from '../services/getMostRelevantBenefit';

export default function useUserHasExpectedBenefits(
  benefitsToFind: ExpectedUserBenefitType | ExpectedUserBenefitType[]
) {
  const { userId, isLoading: isLoadingUser } = useCurrentUserContext();

  const { data: userExpectedBenefits, isFetching: isLoadingExpectedBenefits } =
    useUserExpectedBenefits(
      { userId },
      {
        enabled: Boolean(userId),
      }
    );

  if (isLoadingUser || isLoadingExpectedBenefits) {
    return undefined;
  }

  if (userId === null) {
    return false;
  }

  const a = getMostRelevantBenefit(userExpectedBenefits);
  const benefitList = Array.isArray(benefitsToFind) ? benefitsToFind : [benefitsToFind];

  return a ? benefitList.includes(a) : false;
}
